<template>
  <div class="mergeTableRow">
    <el-table :data="tableDataList" :span-method="objectSpanMethods" border :header-cell-style="{backgroundColor: '#e6f0fc', color: '#000000', 'border-color': '#ffffff'}">
      <el-table-column :label="headerTableText">
        <template v-for="(cols, colIdx) in resolvedColConfigs">
          <!-- 无需合并的列 -->
          <el-table-column
            v-if="!cols.children"
            :key="(cols.prop || cols.labelKey || '') + '-' + colIdx"
            :prop="cols.prop"
            :label="cols.label"
            v-bind="cols.config || {}"
          >
            <template slot-scope="scope">
              <span>{{ cols.formatter ? cols.formatter(scope.row) : isNumberData(scope.row[cols.prop]) }}</span>
            </template>
          </el-table-column>
          <!-- 需要合并的列 -->
          <template v-else-if="cols.children">
            <el-table-column
              v-for="children in cols.children"
              :key="children.prop + '-' + (children.labelKey || '')"
              :prop="children.prop"
              :label="children.label"
              v-bind="children.config || {}"
            >
              <template slot-scope="scope">
                <span>{{ children.formatter ? children.formatter(scope.row) : isNumberData(scope.row[children.prop]) }}</span>
              </template>
            </el-table-column>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'mergeTableRow',
  props: {
    // 表头title内容
    headerTableText: {
      type: String,
      default: ""
    },
    // 表格数据
    tableDataList: {
      type: Array,
      default: () => []
    },
    /**
     * 表格的信息 需要合并的需要放在 children 中
     * 传递格式例如：
     * [
     *   {
     *     children: [
     *             { prop: 'dt', labelKey: 'day' },
     *             { prop: 'grade', labelKey: 'grade' }
     *           ]
     *   },
     *   { prop: 'num', labelKey: 'textsg6l' }
     * ]
     * */
    colConfigs: {
      type: Array,
      default: () => []
    },
    /**
     * 需要合并的行列信息 index必须是table表格对应的下标 不能随意修改
     * 传递格式例如：
     * [
     *  { index: 0, name: 'dt' },
     *  { index: 1, name: 'grade' }
     * ]
     * */
    mergeCols: {
      type: Array,
      default: () => []
    },
    /** 列 labelKey 所在 i18n 模块，默认与业务配置一致 */
    labelI18nModule: {
      type: String,
      default: 'serviceCenter'
    }
  },
  computed: {
    resolvedColConfigs() {
      const mod = this.labelI18nModule
      const resolveLabel = (node) => {
        if (node.labelKey) {
          return this.$t(`${mod}.${node.labelKey}`)
        }
        return node.label || ''
      }
      return this.colConfigs.map((cols) => {
        if (cols.children && cols.children.length) {
          return {
            ...cols,
            children: cols.children.map((ch) => ({
              ...ch,
              label: resolveLabel(ch)
            }))
          }
        }
        return {
          ...cols,
          label: resolveLabel(cols)
        }
      })
    }
  },
  watch: {
    colConfigs: {
      handler() {
        if(this.mergeCols.length > 0) {
          this.newTableMergeData();
        }
      },
      deep: true
    },
    tableDataList: {
      handler() {
        if(this.tableDataList.length > 0) {
          this.newTableMergeData();
        }
      },
      deep: true
    }
  },
  data() {
    return {
      // 用来记录每一个单元格的下标
      tableMergeIndex: [],
    };
  },
  methods: {
    objectSpanMethods({ row, column, rowIndex, columnIndex }) {
      let key = columnIndex + '_' + rowIndex;
      if (this.tableMergeIndex[key]) {
        return this.tableMergeIndex[key];
      }
    },
    newTableMergeData() {
      for (let i = 0; i < this.tableDataList.length; i++) {
        for (let j = 0; j < this.mergeCols.length; j++) {
          // 初始化行、列坐标信息
          let rowIndex = 1;
          let columnIndex = 1;
          // 比较横坐标左方的第一个元素
          if (j > 0 && this.tableDataList[i][this.mergeCols[j]['name']] === this.tableDataList[i][this.mergeCols[j - 1]['name']]) {
            columnIndex = 0;
          }
          // 比较纵坐标上方的第一个元素
          if (i > 0 && this.tableDataList[i][this.mergeCols[j]['name']] === this.tableDataList[i - 1][this.mergeCols[j]['name']]) {
            // 判断当前列的前一列是否与上一列相同，相同的话采用上一列的值
            if (j < 1) {
              rowIndex = 0;
            } else {
              if (this.tableDataList[i][this.mergeCols[j - 1]['name']] === this.tableDataList[i - 1][this.mergeCols[j - 1]['name']]) {
                rowIndex = 0;
              }
            }
          }
          // 比较横坐标右方元素
          if (columnIndex > 0) {
            columnIndex = this.onColIndex(this.tableDataList[i], j, j + 1, 1, this.mergeCols.length);
          }
          // 比较纵坐标下方元素
          if (rowIndex > 0) {
            rowIndex = this.onRowIndex(this.tableDataList, i, i + 1, 1, this.mergeCols[j]['name'], j > 0 ? this.mergeCols[j - 1]['name'] : null);
          }
          let key = this.mergeCols[j]['index'] + '_' + i;
          this.tableMergeIndex[key] = [rowIndex, columnIndex];
        }
      }
      this.$forceUpdate()
    },
    /**
     * 计算列坐标信息
     * data 单元格所在行数据
     * index 当前下标
     * nextIndex 下一个元素坐标
     * count 相同内容的数量
     * maxLength 当前行的列总数
     */
    onColIndex(data, index, nextIndex, count, maxLength) {
      // 比较当前单元格中的数据与同一行之后的单元格是否相同
      if (nextIndex < maxLength && data[this.mergeCols[index]['name']] === data[this.mergeCols[nextIndex]['name']]) {
        return this.onColIndex(data, index, ++nextIndex, ++count, maxLength);
      }
      return count;
    },
    /**
     * 计算行坐标信息
     * data 表格总数据
     * index 当前下标
     * nextIndex 下一个元素坐标
     * count 相同内容的数量
     * name 数据的key
     * lastKeyName 上一个数据的key
     */
    onRowIndex(data, index, nextIndex, count, name, lastKeyName) {
      // 如果当前输入与下一个数据相同并且当前数据的时间与下一个数据的时间不同，直接返回
      if (nextIndex < data.length && data[index][name] === data[nextIndex][name] && data[index][lastKeyName] !== data[nextIndex][lastKeyName]) return count;
      // 比较当前单元格中的数据与同一列之后的单元格是否相同
      if (nextIndex < data.length && data[index][name] === data[nextIndex][name]) {
        return this.onRowIndex(data, index, ++nextIndex, ++count, name, lastKeyName);
      }
      return count;
    },
    isNumberData(data) {
      if (typeof data === 'number') return data
      return data || '/'
    }
  }
};
</script>
<style scoped lang="scss">
.mergeTableRow {
  :deep(.el-table) {
    min-height: 1px;
    .el-table__cell {
      text-align: center;
    }
    .el-table__body tr:hover > td {
      background-color: #fff;
    }
    /* 表单增加border */
    .el-table__row {
      &:first-child {
        td {
          border-bottom: 1px solid #e6f0fc!important;
        }
      }
      td {
        border-left: 1px solid #e6f0fc!important;
        border-bottom: 1px solid #e6f0fc!important;
        &:first-child {
          border-left: 1px solid #e6f0fc !important;
        }
      }
    }
  }
}
</style>